import { LocationType, ProductType, ReceiveType } from './constant';

export const FormatData = ({ data, time }) => {
    if (data && data.length > 0) {
        return data.map(item => {
            const productType = getProductType(item['品名'])
            return {
                ...item,
                '时间': time,
                '估算量': caculateNumber({...item,'物资类型':productType}),
                '区': getDistrict(item['接收单位']),
                '接收单位类型': getCompanyType(item['接收单位']),
                '物资类型': productType,
                '二级分类': getProductSecondType(item),
            }
        })
    }
    return []
}

function calulateMutipdleNumber(string) {
    let tempArray;
    if (!string) {
        return 1
    }
    if (string == '200支') {
        return 200
    }
    if (string.indexOf('/') > 0) {
        tempArray = string.split('/');
        if (tempArray[0].indexOf(',') > 0) {
            let calArray = tempArray[0].split(',')
            return parseInt(tempArray[0].split(',')[calArray.length - 1]) || 1
        }
        if (tempArray[0].indexOf(' ') > 0) {
            let calArray = tempArray[0].split(' ')
            return parseInt(tempArray[0].split(' ')[calArray.length - 1]) || 1
        }
        if (tempArray[0].indexOf('，') > 0) {
            let calArray = tempArray[0].split('，')
            return parseInt(tempArray[0].split('，')[calArray.length - 1]) || 1
        }
        return parseInt(tempArray[0]) || 1
    } else if (string.indexOf('*') > 0) {
        tempArray = string.split('*');
        if (tempArray.length == 2) {
            if (tempArray[0].indexOf('ml')) {
                return parseInt(tempArray[1]) || 1
            }
            return parseInt(tempArray[0]) * parseInt(tempArray[1]) || 1
        } else {
            return 1
        }
    } else if (string == 'EAR200P') {
        return 200
    } else if (string == '平面型耳带式') {
        return 2000
    } else if (string == '9105') {
        return 50
    } else if (parseInt(string) > 0) {
        if (Number(string) == string && Number(string) < 10000) {
            return Number(string) || 1
        } else {
            return 1
        }
    } else {
        return 1
    }
}

function caculateNumber(arrayItem) {
    if (arrayItem['数量']) {
        if (['口罩', '防护服', '手术服', '手套'].includes(arrayItem['物资类型'])) {
            if (!arrayItem['计量单位'] || arrayItem['计量单位'] == '/') {
                return arrayItem['数量']
            } else if (['箱', '件', '盒'].includes(arrayItem['计量单位'])) {
                return arrayItem['数量'] * calulateMutipdleNumber(arrayItem['规格'])
            } else {
                return arrayItem['数量'] * 1
            }
        } else {
            return arrayItem['数量'] * 1
        }

    }
    return '-'
}

function getDistrict(string) {
    if (!string) {
        return ''
    }
    for (let i in LocationType) {
        if (string.indexOf(LocationType[i].value) >= 0) {
            return LocationType[i].value
        }
    }
    return '-'
}

function getCompanyType(string) {
    if (!string) {
        return ''
    }
    for (let i in ReceiveType) {
        if (string.indexOf(ReceiveType[i].value) >= 0) {
            return ReceiveType[i].value
        }
        // if (
        //     includesInArray(string, [
        //     '武汉市江岸区', '武汉市江夏区', '武汉市蔡甸区','武汉市江汉区','东湖风景区管委会',
        //     ])
        // ) {
        //     return '指挥部'
        // }
        if (
            includesInArray(string, [
            '卫生健康局'
            ])
        ) {
            return '卫健局'
        }
    }
    return '-'
}

function includesInArray(string, array) {
    if (array && array.length > 0) {
        for (let i in array) {
            if (string.indexOf(array[i]) >= 0) {
                return true
            }
        }
        return false
    }
    return false
}

function getProductType(string) {
    if (!string) {
        return ''
    }
    for (let i in ProductType) {
        if (string.indexOf(ProductType[i].value) >= 0) {
            return ProductType[i].value
        }
        if (includesInArray(string, ['空气净化器', '新风净化机'])) {
            return '空气净化器'
        }
        if (includesInArray(string, [
            '氨酚烷胺', '泡腾', '利巴韦林', '阿奇霉素', '氯酸烷', '氯酸烷',
            '氯酸烷', '抗病毒口服液', '维生素C泡腾片', '对乙酰氨基酚泡腾片',
            '羧甲司坦泡腾片', '头孢他啶', '利巴韦林', '头孢克洛','盐酸氨溴索',
            '氯化钠','盐酸','碳酸镁片'
        ])) {
            return '西药'
        }
        if (includesInArray(string, [
            '香薷水', '甘草', '板蓝根', '金银花', '一枝蒿', '银花',
            '喉痛灵', '口服液', '清热散结片', '泻肺定喘片'

        ])) {
            return '中成药'
        }
        if (includesInArray(string, [
            '敖东酵素'

        ])) {
            return '保健品'
        }
        if (includesInArray(string, [
            '生脉注射液', '痰热清注射液', '参附注射液'

        ])) {
            return '中药注射液'
        }
    }
    return '-'
}

function getProductSecondType(arrayItem) {
    if (arrayItem['品名']) {
        if (
            includesInArray(arrayItem['品名'], [
                '95', '９５', 'KF94', 'kf94', 'FFP2', 'ffp2', 'good job'

            ])
        ) {
            return 'N95'
        }
    }
    if (arrayItem['规格']) {
        if (
            includesInArray(arrayItem['规格'], [
                '95', '９５', 'KF94', 'kf94', 'FFP2', 'ffp2', 'good job'

            ])
        ) {
            return 'N95'
        }
    }
    if (arrayItem['规格']) {
        if (
            arrayItem['规格'].indexOf('医用') >= 0
        ) {
            return '医用'
        }
    }
    if (arrayItem['品名']) {
        if (
            (
                arrayItem['品名'].indexOf('医用') >= 0
                && arrayItem['品名'].indexOf('非医用') < 0
            )
            || includesInArray(arrayItem['品名'], [
                'SURGITEC', 'BAOTHACH', 'SURGICAL', 'Pasture', 'surgicalface'

            ])
        ) {
            return '医用'
        }
    }
    return '-'
}

export const toThousands = (num) => {
    var result = [],
        counter = 0;
    num = (num || 0).toString()
        .split('');
    for (var i = num.length - 1; i >= 0; i--) {
        counter++;
        result.unshift(num[i]);
        if (!(counter % 3) && i != 0) {
            result.unshift(',');
        }
    }
    return result.join('');
}
const reducer = (accumulator, currentValue) => {
    return (parseInt(accumulator) || 0) + (parseInt(currentValue) || 0);
}
export const getTotalCount = (data) => {
    if (data && data.length > 0) {
        return data.map(item => item['估算量'])
            .reduce(reducer);
    }
    return 0
}
